export const topBarHeight = 64
export const sideNavWidth = 260

export const accountStatus = [
    { type: 'Active', short_name: 'active' },
    { type: "Inactive", short_name: "inactive" }
]

export const FONT_DECORATION = [
    { name: 'none', value: 'none' },
    { name: 'Line Through', value: 'line-through' },
    { name: 'Underline', value: 'underline' },
]

export const FONT_WEIGHT = [
    { name: 'normal', value: 'normal' },
    { name: '100', value: '100' },
    { name: '200', value: '200' },
    { name: '300', value: '300' },
    { name: '400', value: '400' },
    { name: '500', value: '500' },
    { name: '600', value: '600' },
    { name: '700', value: '700' },
]

export const FONT_TYPE = [
    { name: 'Arial', value: 'arial' },
    { name: 'Chap Light', value: 'Chap-Light' },
    { name: 'Helvetica', value: 'Helvetica' },
    { name: 'Knockout', value: 'Knockout-HTF48-Featherweight' },
    { name: 'Akkurat Pro', value: 'AkkuratPro-Regular' },
    { name: 'Bronx Narrow', value: 'Bronx-Narrow' },
    { name: 'Bronx Bold', value: 'Bronx-Bold' },
    { name: 'Bronx Medium', value: 'Bronx-Medium' },
    { name: 'Bronx Diamond', value: 'Bronx-Diamond' },
    { name: 'Bronx Light', value: 'Bronx-Light' },
]

export const FONT_ALIGN = [
    { name: 'Left', value: 'flex-start' },
    { name: 'Center', value: 'center' },
    { name: 'Right', value: 'flex-end' },
]

export const ROTATE_OPTION = [
    { name: '0deg', value: '0deg' },
    { name: '90deg', value: '90deg' },
    { name: '180deg', value: '180deg' },
    { name: '270deg', value: '270deg' },
]

export const globalStyles = { backgroundColor: '#012863' }


export const INITIAL_CUSTOMER_VALUE = {
        profile:{
            title: '',
            preferredName: '',
            firstName: '',
            lastName: '',
            photo:{},
            address: null,
            postal_address: null,
        },
        email: '',
        phone: '',
        storeId: '',
}

export const PHOTO_STATUS = [
    { name: 'Verified', value: 'verified' },
    { name: 'Waiting', value: 'waiting' }
]

export const countries = [{ name: 'Australia', code: 'AU' }]

export const STATES = [
    { name: 'New South Wales', value: 'NSW' },
    { name: 'Victoria', value: 'VIC' },
    { name: 'South Australia', value: 'SA' },
    { name: 'Tasmania', value: 'TAS' },
    { name: 'Australian Capital Territory', value: 'ACT' },
    { name: 'Western Australia', value: 'WA' },
    { name: 'Queensland', value: 'QLD' },
    { name: 'Northern Territory', value: 'NT' }
]